<template>
    <div id="page-content-wrapper" class="admin-content-area">
        <template v-if="cantAccessPage === true">
            <div class="container-fluid xyz">
                <div class="page-header-top-container">
                    <div class="page-name color-71aa3f">{{pageTitle}}</div>

                    <template  v-for="(permission, index) in permissions">
                        <button title="Export" v-if="permission.name == 'can_export_customer_summary_list'" type="button" id='exportEmails' class="btn general-button btn-primary icon-btn"
                                v-on:click="loadCustomerSummary(1)">
                            <i class="fa fa-cloud-download" aria-hidden="true"></i>
                        </button>
                    </template>
                </div>
                <div class="admin-page-content">
                    <div class="app-filter-good-table-container">
                        <vue-good-table class="jobList"
                                        ref="listCustomerSummaryTable"
                                        mode="remote"
                                        title="Customer Summary"
                                        @on-page-change="onPageChange"
                                        @on-selected-rows-change="selectionChanged"
                                        @on-column-filter="onColumnFilter"
                                        @on-per-page-change="onPerPageChange"
                                        @on-sort-change="onSortChange"
                                        :totalRows="totalRecords"
                                        :columns="columns"
                                        :rows="rows"
                                        :pagination-options="{
                                        enabled: true,
                                        mode: 'pages',
                                        pageLabel: 'Page',
                                        position: 'bottom',
                                        perPage: serverParams.perPage,
                                        setCurrentPage: serverParams.setCurrentPage,
                                        perPageDropdown: customPerPageArr,
                                        dropdownAllowAll: false,
                                        }"
                                        :search-options="{
                                        enabled: false,
                                        }">
                            <template slot="pagination-bottom" slot-scope="props">
                                <div class="vgt-wrap__footer crm">
                                    <div  class="row">
                                        <div class="col-sm-12 col-md-2 PerPage">
                                            <v-select title="Select Per Page"
                                                      v-model="serverParams.perPage"
                                                      @change="changedValue"
                                                      @input="changedValueCustomPerPage()"
                                                      name="customPerPage"
                                                      id="customPerPage"
                                                      label="text"
                                                      :clearable="false"
                                                      :searchable="false"
                                                      :filterable="false"
                                                      :options="customPerPageArr"
                                                      placeholder="Select Per Page">
                                            </v-select>
                                        </div>
                                        <div class="mt-2 col-sm-12 col-md-2 RowsDisplay">
                                            <p class="pageRowCount">{{paginationDisplayRows}} of {{totalRecords}}</p>
                                        </div>
                                        <div class="col-sm-12 col-md-6 Pagination">
                                            <ul class="pagination">
                                                <li class="page-item FirstPage" title="First Page">
                                                    <template v-if="Number(serverParams.page) == 1">
                                                        <a class="page-link" href="javascript:void(0)">1</a>
                                                    </template>
                                                    <template v-else>
                                                        <a v-on:click="onPerticularPageClick(1)" class="page-link" href="javascript:void(0)">1</a>
                                                    </template>
                                                </li>
                                                <li class="page-item PreviousPage" title="Previous Page">
                                                    <template v-if="Number(serverParams.page) == 1">
                                                        <a class="page-link" href="javascript:void(0)" tabindex="-1"><i class="fa fa-angle-left"></i></a>
                                                    </template>
                                                    <template v-else>
                                                        <a class="page-link" href="javascript:void(0)" tabindex="-1" v-on:click="onPerticularPageClick(Number(serverParams.page)-1)" ><i class="fa fa-angle-left"></i></a>
                                                    </template>
                                                </li>
                                                <!--New Implementation-->
                                                <template v-if="pageNumberList() < displayPage">
                                                    <template v-for="(n, index) in pageNumberList()">
                                                        <li :title="'Page ' +n" class="PagesClass page-item active" v-bind:id="'pageNumber' + n" v-if="n == Number(serverParams.page)">
                                                            <a class="page-link" href="javascript:void(0)">
                                                                {{n}}
                                                            </a>
                                                        </li>
                                                        <li :title="'Page ' +n" v-on:click="onPerticularPageClick(n)" class="PagesClass page-item" v-bind:id="'pageNumber' + n" v-else>
                                                            <a class="page-link" href="javascript:void(0)">
                                                                {{n}}
                                                            </a>
                                                        </li>
                                                    </template>
                                                </template>
                                                <template v-else>
                                                    <!--End New Implementation-->
                                                    <template v-if="Number(serverParams.page) <= pageCompare">
                                                        <template v-for="(n, index) in displayPage">
                                                            <li :title="'Page ' +n" class="PagesClass page-item active" v-bind:id="'pageNumber' + n" v-if="n == Number(serverParams.page)">
                                                                <a class="page-link" href="javascript:void(0)">
                                                                    {{n}}
                                                                </a>
                                                            </li>
                                                            <li :title="'Page ' +n" v-on:click="onPerticularPageClick(n)" class="PagesClass page-item" v-bind:id="'pageNumber' + n" v-else>
                                                                <a class="page-link" href="javascript:void(0)">
                                                                    {{n}}
                                                                </a>
                                                            </li>
                                                        </template>
                                                    </template>
                                                    <template v-else-if="Number(serverParams.page) >= (pageNumberList() - (pageCompare-1))">
                                                        <template v-for="(n, index) in pageNumberList()">
                                                            <template v-if="n > (pageNumberList() - displayPage)">
                                                                <li :title="'Page ' +n" class="PagesClass page-item active" v-bind:id="'pageNumber' + n" v-if="n == Number(serverParams.page)">
                                                                    <a class="page-link" href="javascript:void(0)">
                                                                        {{n}}
                                                                    </a>
                                                                </li>
                                                                <li :title="'Page ' +n" v-on:click="onPerticularPageClick(n)" class="PagesClass page-item" v-bind:id="'pageNumber' + n" v-else>
                                                                    <a class="page-link" href="javascript:void(0)">
                                                                        {{n}}
                                                                    </a>
                                                                </li>
                                                            </template>
                                                        </template>
                                                    </template>
                                                    <template v-else>
                                                        <template v-for="(n, index) in pageNumberList()" v-if="(n >= (Number(serverParams.page) - (pageCompare -1))) && (n <= (Number(serverParams.page) + (pageCompare -1)))">
                                                            <li :title="'Page ' +n" class="PagesClass page-item active" v-bind:id="'pageNumber' + n" v-if="n == Number(serverParams.page)">
                                                                <a class="page-link" href="javascript:void(0)">
                                                                    {{n}}
                                                                </a>
                                                            </li>
                                                            <li :title="'Page ' +n" v-on:click="onPerticularPageClick(n)" class="PagesClass page-item" v-bind:id="'pageNumber' + n" v-else>
                                                                <a class="page-link" href="javascript:void(0)">
                                                                    {{n}}
                                                                </a>
                                                            </li>
                                                        </template>
                                                    </template>
                                                </template>
                                                <li class="page-item NextPage" title="Next Page">
                                                    <template v-if="Number(serverParams.page) == pageNumberList()">
                                                        <a class="page-link" href="javascript:void(0)"><i class="fa fa-angle-right"></i></a>
                                                    </template>
                                                    <template v-else>
                                                        <a class="page-link" href="javascript:void(0)" v-on:click="onPerticularPageClick(Number(serverParams.page)+1)"><i class="fa fa-angle-right"></i></a>
                                                    </template>
                                                </li>
                                                <li class="page-item LastPage" title="Last Page">
                                                    <template v-if="Number(serverParams.page) == pageNumberList()">
                                                        <a class="page-link" href="javascript:void(0)" tabindex="-1">{{pageNumberList()}}</a>
                                                    </template>
                                                    <template v-else>
                                                        <a v-on:click="onPerticularPageClick(pageNumberList())" class="page-link" href="javascript:void(0)" tabindex="-1">{{pageNumberList()}}</a>
                                                    </template>
                                                </li>
                                            </ul>
                                        </div>
                                        <div class="mt-2 col-lg-1 col-md-1 col-sm-2 col-xs-6">
                                            <p class="pageJumpLabel">Page : </p>
                                        </div>
                                        <div class="mt-1 col-lg-1 col-md-1 col-sm-2 col-xs-6">
                                            <input v-model="jumpToPage" type="text" class="form-control form-control-sm" name="jumpToPage" id="jumpToPage" placeholder="Page">
                                        </div>
                                    </div>
                                </div>
                            </template>
                            <template slot="table-row" slot-scope="props" v-for="(row,key) in rows">
                                <div :key="key">
                                    <div v-if="props.column.field == 'action'">
                                        <template v-if="permission.name == 'can_change_email_bounce_status'" v-for="(permission, index) in permissions">
                                            <template v-if="props.row.status == 'block'">
                                                <button :key="index" title='Unblock it' v-on:click="onEmailBounceStatusChange(props.row.id)" class="btn edit-btn-vvg">
                                                    <i class="fa fa-eye-slash"></i>
                                                </button>
                                            </template>
                                            <template v-else>
                                                <button :key="index" title='Block it' v-on:click="onEmailBounceStatusChange(props.row.id)" class="btn edit-btn-vvg">
                                                    <i class="fa fa-eye"></i>
                                                </button>
                                            </template>
                                        </template>
                                    </div>
                                    <div v-else>
                                        {{props.formattedRow[props.column.field]}}
                                    </div>
                                </div>
                            </template>
                            <div slot="selected-row-actions" slot-scope="computed">
                                {{computed.selectedRows}}
                                <button title="Change Email Bounce Status" class="btn general-button btn-success waves-effect" v-on:click="onEmailBounceStatusChange()">Change Status</button>
                            </div>
                        </vue-good-table>
                    </div>
                </div>
            </div>
        </template>
        <template v-else>
            <div class="admin-page-content">
                <div class="col-md-12 error-detail-main forms-container">
                    <div class="error-template">
                        <h1>Oops!</h1>
                        <h2>403</h2>
                        <div class="error-details">Sorry!, You don't have permission to access this page.</div>
                    </div>
                </div>
            </div>
        </template>
        <app-footer></app-footer>
    </div>
</template>

<script>
    import {list_customerUrl, configs} from '../../config';
    import Vue from 'vue';
    import VueGoodTable from 'vue-good-table';
    import 'vue-good-table/dist/vue-good-table.css';
    import {listCustomer} from '../../config';
    import FrontFooter from '@/components/partials/FrontFooter';
    import EventBus from '../event-bus';
    import swal from 'sweetalert2/dist/sweetalert2.js';
    const Swal = require('sweetalert2');
    import SessioMixin from '../../mixins/sessionmixin';

    Vue.use(VueGoodTable);
    var self;
    export default {
        name: "listCustomerSummary",
        mixins: [SessioMixin],
        components: {
            'app-footer': FrontFooter,
        },
        data: () => ({
            cantAccessPage: true,
            pageTitle: 'Customer Credit Limits Review',
            loginID: 0,
            isLoggedIn: false,
            permissions: [],
            displayPage: 7,
            pageCompare: 0,
            paginationDisplayRows: '',
            jumpToPage: 0,
            customPerPageArr: ['25', '50', '100', '200', '500'],
            columns: [
                /*{
                    label: 'Customer Id',
                    field: 'customer_id',
                    filterable: true,
                    filterOptions: {
                        enabled: true, // enable filter for this column
                        placeholder: "Customer Id", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter", //only trigger on enter not on keyup
                        filterFn: this.onColumnFilter,
                    }
                },*/
                {
                    label: 'BillTo Cust#',
                    field: 'billcusid',
                    filterable: true,
                    filterOptions: {
                        enabled: true, // enable filter for this column
                        placeholder: "CusId", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter", //only trigger on enter not on keyup
                        filterFn: this.onColumnFilter,
                    }
                },
                {
                    label: 'Bill To Cust Name',
                    field: 'name',
                    filterable: true,
                    filterOptions: {
                        enabled: true, // enable filter for this column
                        placeholder: "Name", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter", //only trigger on enter not on keyup
                        filterFn: this.onColumnFilter,
                    }
                },
                // {
                //     label: 'Collector',
                //     field: 'collector',
                //     filterable: true,
                //     filterOptions: {
                //         enabled: true, // enable filter for this column
                //         placeholder: "Collector", // placeholder for filter input
                //         filterValue: '', // initial populated value for this filter
                //         trigger: "enter", //only trigger on enter not on keyup
                //         filterFn: this.onColumnFilter,
                //     }
                // },
                {
                    label: 'Avg Days to Pay',
                    field: 'days_paymen_avg',
                    filterable: true,
                    type: 'number',
                    filterOptions: {
                        enabled: true, // enable filter for this column
                        placeholder: "From | To", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter", //only trigger on enter not on keyup
                        filterFn: this.onColumnFilter,
                    }
                },
                {
                    label: 'Credit Limit',
                    field: 'amt_cr_limit',
                    filterable: true,
                    type: 'number',
                    filterOptions: {
                        enabled: true, // enable filter for this column
                        placeholder: "From | To", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter", //only trigger on enter not on keyup
                        filterFn: this.onColumnFilter,
                    }
                },
                {
                    label: 'Avg Monthly Sales',
                    field: 'avg_sales_12months',
                    filterable: true,
                    type: 'number',
                    filterOptions: {
                        enabled: true, // enable filter for this column
                        placeholder: "From | To", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter", //only trigger on enter not on keyup
                        filterFn: this.onColumnFilter,

                    }
                },
                /* {
                    label: 'Term Id',
                    field: 'trm_id',
                    filterable: true,
                    filterOptions: {
                        enabled: true, // enable filter for this column
                        placeholder: "Term Id", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter", //only trigger on enter not on keyup
                        filterFn: this.onColumnFilter,
                    }
                }, */

                {
                    label: 'Prior Month’s Sales',
                    field: 'sales_1month',
                    filterable: true,
                    type: 'number',
                    filterOptions: {
                        enabled: true, // enable filter for this column
                        placeholder: "From | To", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" ,//only trigger on enter not on keyup
                        filterFn: this.onColumnFilter,
                    }
                },
                /* {
                    label: 'Profit 1Month',
                    field: 'profit_1month',
                    filterable: true,
                    type: 'number',
                    filterOptions: {
                        enabled: true, // enable filter for this column
                        placeholder: "Profit 1Month", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter", //only trigger on enter not on keyup
                        filterFn: this.onColumnFilter,
                    }
                }, */
                {
                    label: 'Prior x2 Month’s Sales',
                    field: 'sales_2month',
                    filterable: true,
                    type: 'number',
                    filterOptions: {
                        enabled: true, // enable filter for this column
                        placeholder: "From | To", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter", //only trigger on enter not on keyup
                        filterFn: this.onColumnFilter,

                    }
                },
                /* {
                    label: 'Profit 2Month',
                    field: 'profit_2month',
                    filterable: true,
                    type: 'number',
                    filterOptions: {
                        enabled: true, // enable filter for this column
                        placeholder: "Profit 2Month", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter", //only trigger on enter not on keyup
                        filterFn: this.onColumnFilter,

                    }
                }, */
                {
                    label: 'Prior x3 Month’s Sales',
                    field: 'sales_3month',
                    filterable: true,
                    type: 'number',
                    filterOptions: {
                        enabled: true, // enable filter for this column
                        placeholder: "From | To", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter", //only trigger on enter not on keyup
                        filterFn: this.onColumnFilter,

                    }
                },
                /* {
                    label: 'Profit 3Month',
                    field: 'profit_3month',
                    filterable: true,
                    type: 'number',
                    filterOptions: {
                        enabled: true, // enable filter for this column
                        placeholder: "Profit 3Month", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter", //only trigger on enter not on keyup
                        filterFn: this.onColumnFilter,

                    }
                }, */
                /* {
                    label: 'Avg profit 12Months',
                    field: 'avg_profit_12months',
                    filterable: true,
                    type: 'number',
                    filterOptions: {
                        enabled: true, // enable filter for this column
                        placeholder: "Avg profit 12Months", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter", //only trigger on enter not on keyup
                        filterFn: this.onColumnFilter,

                    }
                }, */
                /* {
                    label: 'Credit Usage',
                    field: 'credit_usage',
                    filterable: true,
                    type: 'number',
                    filterOptions: {
                        enabled: true, // enable filter for this column
                        placeholder: "Credit Usage", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter", //only trigger on enter not on keyup
                        filterFn: this.onColumnFilter,

                    }
                }, */
                {
                    label: 'Recommend',
                    field: 'credit_status',
                    filterable: true,
                    filterOptions: {
                        enabled: true, // enable filter for this column
                        placeholder: "Recommend", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        filterDropdownItems: ['As Is', 'Decrease', 'Increase'], // dropdown (with selected values) instead of text input
                        trigger: "enter", //only trigger on enter not on keyup
                        filterFn: this.onColumnFilter,

                    }
                },
                {
                        label: 'Created Date',
                        field: 'date_create',
                        filterable: true,
                        filterOptions: {
                            enabled: true, // enable filter for this column
                            placeholder: "From | To", // placeholder for filter input
                            filterValue: '', // initial populated value for this filter
                            trigger: "enter", //only trigger on enter not on keyup

                        }
                    },
                /*{
                    label: 'Action',
                    field: 'action',
                    sortable: false,
                    thClass: 'disable-sorting',
                }*/
            ],
            rows: [],
            totalRecords: 0,
            serverParams: {
                columnFilters: {},
                sort: {
                    field: 'id',
                    type: 'desc',
                },
                page: 1,
                perPage: 25,
                setCurrentPage: 1,
            },
        }),
        mounted: function () {
            self.jumpToPage = self.serverParams.page;
            self.pageCompare = Math.ceil(self.displayPage / 2);
            $("#jumpToPage").on('keyup', function (e) {
                if (e.keyCode === 13) {  //checks whether the pressed key is "Enter"
                    self.jumpToInputPage(self.jumpToPage)
                }
            });
            $(".removeActive").removeClass('active');
            $("#menucustomersummary").addClass('active');
            if (localStorage.getItem("menu_small") == '1') {
                this.menuSmall();
            } else {
                this.menuBig();
            }
            self.showLoader();
            this.loadCustomerSummary(0);
            var userObj = localStorage.getItem('user_obj');
            if (userObj != null) {
                var userJson = JSON.parse(userObj);
                EventBus.$emit("logged-in", false, userJson["first_name"], userJson["last_name"], userJson["email"]);
            }

        },
        beforeMount: function () {
            self = this;
            var check = window.localStorage.getItem('api_token');

            if (check != null) {
                this.isLoggedIn = true;
                self.getPermissions();
            }
        },
        methods: {
            getPermissions: function () {
                $.ajax({
                    url: process.env.ROOT_API + "/user/permission",
                    type: "POST",
                    headers: {
                        'Accept': 'application/json',
                        "Access-Control-Allow-Origin": '*',
                        "Authorization": "Bearer " + localStorage.getItem("api_token"),
                        'Access-Control-Allow-Headers': 'Origin, Content-Type, Authorization,X-Requested-With',
                        "Cache-Control": "no-cache"
                    },
                    dataType: 'json',
                    success: function (data) {
                        if (data.status == 'success') {
                            self.cantAccessPage = false;
                            self.permissions = data.content;
                            let current_build = window.localStorage.getItem("build_version");
                            let latest_build = data.build;
                            if (current_build != undefined && current_build == '') {
                                localStorage.setItem("build_version", data.build);
                            } else if (current_build != latest_build) {
                                localStorage.setItem("build_version", data.build);
                                location.reload(true);
                            }
                            if (self.permissions.length > 0) {
                                for (var i = 0; i < self.permissions.length; i++) {
                                    if (self.permissions[i].name == 'can_see_customer_summary_list') {
                                        self.cantAccessPage = true;
                                    }
                                }
                            }
                        }
                    },
                    error: function (jqXHR, exception) {
                        self.cantAccessPage = false;
                        if (jqXHR.status == 0) {
                            self.error = "Remote server can not be reachable";
                        } else {
                            //redirect to login page if user not authenticated
                            if (jqXHR.status == 401) {
                                //clear previous data
                                localStorage.removeItem('user_obj');
                                localStorage.removeItem('api_token');
                                //EventBus.$emit("logged-in", true, "", "");
                                self.$router.push("/login");
                            }
                            self.error = jqXHR.responseJSON.message;
                        }
                    }
                });
            },
            changedValue: function (value) {
                /*console.log(value);*/
            },
            jumpToInputPage: function (pageNumber) {
                var self = this;
                var reg = /^\d+$/;
                if (pageNumber <= 0 || pageNumber == '') {
                    pageNumber = 1;
                } else if (pageNumber > self.pageNumberList()) {
                    pageNumber = self.pageNumberList();
                    if (pageNumber <= 0 || pageNumber == '') {
                        pageNumber = 1;
                    }
                } else if (!String(self.jumpToPage).match(reg)) {
                    pageNumber = 1;
                }
                self.onPerticularPageClick(pageNumber);
            },
            onPerticularPageClick: function (pageNumber) {
                var self = this;
                self.serverParams.page = pageNumber;
                self.jumpToPage = pageNumber;
                /* Single Backend Call on page load start */
                if(self.firstLoad != 1 && self.jumpToPage != 1) {
                    self.loadCustomerSummary(0);
                } else if(self.firstLoad == 1 && self.jumpToPage >=1) {
                    self.loadCustomerSummary(0);
                }
                /* Single Backend Call on page load end */
            },
            pageNumberList: function () {
                var self = this;
                var totalRecord = self.totalRecords;
                var count = 0;
                for (var i = 0; totalRecord > 0; i++) {
                    totalRecord = totalRecord - self.serverParams.perPage;
                    count++;
                }
                return count;
            },
            changedValueCustomPerPage: function () {
                var self = this;
                /* Single Backend Call on page load start */
                if(self.firstLoad != 1) {
                    self.jumpToInputPage(self.serverParams.page);
                    self.loadCustomerSummary(0);
                }
                /* Single Backend Call on page load end */
            },
            updateParams(newProps) {
                this.serverParams = Object.assign({}, this.serverParams, newProps);
            },
            //
            onPageChange(params) {
                this.updateParams({page: params.currentPage});
                this.loadCustomerSummary(0);
            },
            //
            onPerPageChange(params) {
                this.updateParams({perPage: params.currentPerPage});
                this.totalRecords = self.totalRecords;
                this.loadCustomerSummary(0);
            },
            onColumnFilter(params) {
                this.updateParams(params);
                {
                    field: ('customer_id');
                    field: ('cusid');
                    field: ('name');
                    field: ('amt_cr_limit');
                    field: ('trm_id');
                    field: ('days_paymen_avg');
                    field:('sales_1month');
                    field:('profit_1month');
                    field:('sales_2month');
                    field:('profit_2month');
                    field:('sales_3month');
                    field:('profit_3month');
                    field:('avg_sales_12months');
                    field:('avg_profit_12months');
                    field:('credit_usage');
                }
                ;
                this.serverParams.page = 1;
                var filtersPr = JSON.parse(JSON.stringify(this.serverParams));
                var filters = filtersPr.columnFilters;
                if (this.firstLoad == 1 || filters.customer_id || filters.cusid || filters.name || filters.amt_cr_limit
                    || filters.trm_id || filters.days_paymen_avg || filters.sales_1month || filters.profit_1month
                    || filters.sales_2month || filters.profit_2month || filters.sales_3month || filters.profit_3month
                    || filters.avg_sales_12months || filters.avg_profit_12months || filters.credit_usage) {
                    this.loadCustomerSummary();
                }
            },
            selectionChanged() {
                // console.log( this.computed.selectedRows);
                // var rowData = self.$refs['my-table'].selectedRows;
                // console.log(rowData);
            },
            onSortChange(params) {
                this.updateParams({
                    sort: {
                        /* type: params.sortType,
                        field: this.columns[params.columnIndex].field, */
                        type: params[0].type,
                        field: params[0].field,
                    },
                });
                this.loadCustomerSummary(0);
            },
            loadCustomerSummary: function (isExport) {
                self.serverParams.setCurrentPage = self.serverParams.page;
                var fields = {
                    page: self.serverParams.page,
                    perPage: self.serverParams.perPage,
                    filters: self.serverParams.columnFilters,
                    sort: self.serverParams.sort,
                    isExport: isExport
                };
                this.firstLoad = 1;
                self.showLoader();
                $.ajax({
                    url: process.env.ROOT_API + "/list_customer_summary",
                    type: "POST",
                    data: fields,
                    headers: {
                        'Accept': 'application/json',
                        "Access-Control-Allow-Origin": '*',
                        "Authorization": "Bearer " + localStorage.getItem("api_token"),
                        'Access-Control-Allow-Headers': 'Origin, Content-Type, Authorization,X-Requested-With',
                        "Cache-Control": "no-cache"
                    },
                    dataType: 'json',
                    success: function (data) {
                        if (data.code == '200') {
                            if (data.message == "success export") {
                                self.downloadFile(data.content.web);
                                // location.href = data.content.web;
                            } else {
                                self.rows = data.content.row;
                                self.totalRecords = data.content.totalRecords;
                                self.showHidePagination("jobList", self.totalRecords);
                                self.jumpToPage = self.serverParams.page;
                            }
                        }
                        self.paginationDisplayRows = self.getRecords(self.serverParams.page, self.serverParams.perPage, self.totalRecords);
                        self.hideLoader();
                    },
                    error: function (jqXHR, exception) {
                        self.hideLoader();
                        if (jqXHR.status == 0) {
                            self.error = "Remote server can not be reachable";
                        } else {
                            //redirect to login page if user not authenticated
                            if (jqXHR.status == 401) {
                                //clear previous data
                                localStorage.removeItem('user_obj');
                                localStorage.removeItem('api_token');
                                //EventBus.$emit("logged-in", true, "", "");
                                self.$router.push("/login");
                            }
                            self.error = jqXHR.responseJSON.message;
                        }
                    }
                });
            },

            menuSmall: function () {
                $('.opensidebar').show();
                $('.closesidebar').hide();
                $('.menu').addClass('menusmall');
                $('.sidemenu li a span,.legal').addClass('displaynone');
                $('.sidemenu li a i').addClass('displayicons');
                $('.sidebar').css({width: "70px"});
                $('.content').css({marginLeft: "70px"});
            },
            menuBig: function () {
                $('.opensidebar').hide();
                $('.closesidebar').show();
                $('.menu').removeClass('menusmall');
                $('.sidemenu li a span,.legal').removeClass('displaynone');
                $('.sidemenu li a i').removeClass('displayicons');
                $('.sidebar').css({width: "260px"});
                $('.content').css({marginLeft: "260px"});
            }
        }
    }
</script>
<style>
    .vgt-checkbox-col input {
        opacity: 1 !important;
        position: static !important;
    }
</style>


// WEBPACK FOOTER //
// src/components/customerSummary/ListCustomerSummary.vue